export default function($) {
  var hover_large = $('.js-link-hover-large');
  var no_hover = $('.js-no-link-hover');

  hover_large.find('a').on( 'mouseover', function () {
    $(this).closest('.js-link-hover-large').find('img').css('transform', 'scale(1.1)');
    $(this).closest('.js-link-hover-large').find('.title').css('text-decoration', 'underline');
  } )
  hover_large.find('a').on( 'mouseleave', function () {
    $(this).closest('.js-link-hover-large').find('img').css('transform', 'scale(1)');
    $(this).closest('.js-link-hover-large').find('.title').css('text-decoration', 'none');
  } )
}
